module.exports = __webpack_public_path__ + "img/ai_bot_avatar.fcd68d48.png";